import { createAsyncThunk } from "@reduxjs/toolkit";
import QuestsServices from "../../Services/QuestsServices";

export const fetchQuests = createAsyncThunk(
  "quests/fetchQuests",
  async (campaign, { rejectWithValue }) => {
    try {
      const response = await QuestsServices.getQuests(campaign);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchQuestById = createAsyncThunk(
  "quests/fetchQuestById",
  async (questId, { rejectWithValue }) => {
    try {
      const response = await QuestsServices.getQuestById(questId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
